import React from 'react';

import SoftySupervisor from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftySupervisor/List.js';

export default function () {
  return <SoftySupervisor />;
}
